import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { forum_post_path } from '../../../routes';
import { ForumPost } from '../../../utils/backend-api/forumPosts';
import UserProfileLink from '../../User/UserProfileLink';
import { userName } from '../../User/userHelpers';
import { FlexLink, TimeAgo } from '../../shared';
import ForumPostActions from '../ForumPostActions';
import ForumTags from '../ForumTags';
import styles from './styles.module.scss';

export default function ForumPostListItem({ forumPost }: { forumPost: ForumPost }) {
  const {
    comment: { user },
  } = forumPost;
  const body = ReactHtmlParser(forumPost.comment.snippet);

  return (
    <div className={styles.forumPost} data-test="forum-post">
      <FlexLink href={forum_post_path(forumPost.id)} className={styles.forumPostHeading}>
        <div className={styles.forumPostTitle}>{forumPost.title}</div>
        <TimeAgo className={styles.forumPostDate} date={forumPost.created_at} />
      </FlexLink>
      <div className={styles.postedBy}>
        Posted by
        <UserProfileLink user={user} className={styles.userInfo}>
          {userName(user)}
          {!!user.company_name && (
            <>
              <div className={styles.userInfoSeparator} />
              <div>{user.company_name}</div>
            </>
          )}
        </UserProfileLink>
      </div>
      <FlexLink href={forum_post_path(forumPost.id)} className={styles.forumPostBody}>
        {body}
      </FlexLink>
      <div className={styles.forumPostFooter}>
        <ForumTags tags={forumPost.manual_entities} small={true} />
        <ForumPostActions forumPost={forumPost} minimal={true} />
      </div>
    </div>
  );
}
